import React from 'react';
import '../css/TermsOfService.css';

const TeslimatVeIade = () => {
  return (
    <div className="tos-container">
      <h1 className="tos-title">Teslimat ve İade Politikası</h1>

      <section>
        <h3>1. Hizmet Teslimi</h3>
        <p>
          Halısahacım.com üzerinden yapılan ödeme işlemleri, kullanıcıya dijital hizmet sağlamak amacıyla yapılmaktadır. Fiziksel ürün teslimi bulunmamaktadır.
          Ödeme tamamlandıktan sonra işletme hesabı 30 gün boyunca aktifleştirilir ve sistemde görünür hale gelir.
        </p>
      </section>

      <section>
        <h3>2. İade Şartları</h3>
        <p>
          Hizmet dijital olduğu için, hizmetten faydalanılmaya başlanmamışsa (ilk rezervasyon alınmamışsa) ödeme tarihinden itibaren 3 gün içerisinde iade talebinde bulunulabilir.
          İade talepleri <a href="mailto:halisahacim.com@gmail.com">halisahacim.com@gmail.com</a> adresine gönderilmelidir.
        </p>
      </section>

      <section>
        <h3>3. İade Süreci</h3>
        <p>
          İade talepleri, kullanıcının ödeme bilgileri doğrulanarak 5 iş günü içerisinde incelenir. Onaylanan iadeler, ödeme yöntemine bağlı olarak 7 iş günü içinde kullanıcıya aktarılır.
        </p>
      </section>

      <section>
        <h3>4. İletişim</h3>
        <p>
          Teslimat veya iade süreçleri ile ilgili sorularınız için bizimle <a href="mailto:halisahacim.com@gmail.com">halisahacim.com@gmail.com</a> üzerinden iletişime geçebilirsiniz.
        </p>
      </section>
    </div>
  );
};

export default TeslimatVeIade;
